import { defineMessages } from 'react-intl';
// import Schema from '@plone/volto/components/manage/Blocks/Block/Schema';
import Edit from './Edit';
import View from './View';
import iconSVG from './icons/head-title.svg';

defineMessages({
  headTitle: {
    id: 'Content head title',
    defaultMessage: 'Content head title',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.headTitleBlock = {
    id: 'headTitleBlock',
    title: 'Content head title',
    group: 'contentProperties',
    icon: iconSVG,
    view: View,
    edit: Edit,
    // schema: headingSchema,
    hide_alignment: false,
    sidebarTab: 0,
    restricted: ({ properties, block }) =>
      !('head_title' in properties) ||
      properties.blocks_layout?.items?.find(
        (uid) => properties.blocks?.[uid]?.['@type'] === block.id,
      ),
    mostUsed: false,
    blockHasOwnFocusManagement: true,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
